import React, { FC, HTMLAttributes } from 'react'
import { Text } from '../Text/Text'
import { TextTypes } from '../../../types'

interface TextWithUnitProps extends Omit<HTMLAttributes<HTMLSpanElement>, 'prefix'> {
    children: React.ReactNode
    prefix?: string | React.ReactNode
    suffix?: string | React.ReactNode
}

export const TextWithUnit: FC<TextWithUnitProps> = ({ children, prefix, suffix, className, ...props }) => {
    return (
        <span className={`inline-flex items-center gap-2 ${className}`} {...props}>
            {prefix && <Text type={TextTypes.SMALL_TEXT}>{prefix}</Text>}
            {children}
            {suffix && <Text type={TextTypes.SMALL_TEXT}>{suffix}</Text>}
        </span>
    )
}
